// extracted by mini-css-extract-plugin
export default {"check_cube":"check_cube___dXnTf","checks":"checks___J8ZWh","short":"short___I1jUz"};